import { deleteMedida, getMedidasPanel} from "../../services/MedidasServices";
import { MedidasContext } from "./MedidasContext"

export const MedidasState = ({ children }) => {
    
    const getMedidasPanelData = async (search,numpag,filas) => {
        let res = await getMedidasPanel(search,numpag,filas)
        return res
    }

    const deleteMedidaData = async (body,search,numpag,filas) => {
        const res = await deleteMedida(body)
        if (res) getMedidasPanelData(search,numpag,filas)
        return res
    }

    return <MedidasContext.Provider value={{
        deleteMedidaData,
        getMedidasPanelData,
    }} >
        {children}
    </MedidasContext.Provider>
}